module.exports = __webpack_public_path__ + "media/images/emblems/Gommiswald-blazono-f81d43ae1c40f55eed1b6cbc1ce64ab6.png";